module.exports = window.Element.prototype.matches || function (selector) {
  // 'document' case may cause some bugs
  // in case element doesn't belong to the document
  const scope = this.parentNode || this.document || document;
  const nodes = scope.querySelectorAll(selector);
  let i = -1;

  while (nodes[++i] && nodes[i] != this);

  return !!nodes[i];
};
